import React from "react";
import { FaComments } from "react-icons/fa";

export const Chats = () => {
  return (
    <div className="text-center py-20 text-gray-500">
      <FaComments size={60} className="mx-auto mb-4 text-gray-300" />
      Chats coming soon...
    </div>
  );
};
